import { styled } from "baseui";
import { getMargin } from "@bluecrew/blueprint-web";

export const ModalFooterWrapper = styled("div", ({ $theme }) => ({
  ...getMargin($theme.sizing.scale600),
  display: "flex",
  flexDirection: "row",
}));
